import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const pageLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.notification-settings', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageLoad,
	}),
);
